// import Swal from "sweetalert2";
// import withReactContent from 'sweetalert2-react-content'
// const MySwal = withReactContent(Swal)

// const topTost = () => {
//     MySwal.mixin({
//         toast: true,
//         position: 'top-end',
//         showConfirmButton: false,
//         timer: 3000,
//         timerProgressBar: true,
//         backdrop:false,
//         didOpen: (toast) => {
//             toast.addEventListener('mouseenter', Swal.stopTimer);
//             toast.addEventListener('mouseleave', Swal.resumeTimer);
//         }
//     }).fire({
//         icon: 'success',
//         title: 'Action Execute Successfully'
//     });
// }

// export default topTost


import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

/**
 * Universal toast notification using SweetAlert2.
 *
 * @param {Object} options
 * @param {'success' | 'error' | 'warning' | 'info' | 'question'} options.icon - Type of the toast.
 * @param {string} options.title - Message to show in the toast.
 * @param {number} [options.timer=3000] - Duration to show the toast (ms).
 * @param {'top' | 'top-start' | 'top-end' | 'center' | 'center-start' | 'center-end' | 'bottom' | 'bottom-start' | 'bottom-end'} [options.position='top-end'] - Position of the toast.
 */
const topTost = ({
  icon = "success",
  title = "Action successfully",
  timer = 3000,
  position = "top-end",
} = {}) => {
  MySwal.mixin({
    toast: true,
    position,
    showConfirmButton: false,
    timer,
    timerProgressBar: true,
    backdrop: false,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  }).fire({
    icon,
    title,
  });
};

export default topTost;
